import { render, staticRenderFns } from "./logsFilterBar.vue?vue&type=template&id=945db6fa&"
import script from "./logsFilterBar.vue?vue&type=script&lang=js&"
export * from "./logsFilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports